import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(() => ({
  beatsourcePlayBarPlaceholder: {
    height: '64px',
    width: '100%',
    position: 'fixed',
    left: 0,
    bottom: 0,
    zIndex: 9999,
  },
}));

export default useStyles;
